module.exports = __webpack_public_path__ + "img/func-detail-0.b84f5005.png";